import { Button, Flex, Paper, Select, TextInput } from "@mantine/core";
import { useUnit } from "effector-react";
import { DatePickerInput } from "@mantine/dates";

import { articlesEntityModel } from "../../model/list";
import { ArticleStatus } from "../../types";

export const ArticlesFilters = () => {
  const [filters, update, apply, reset] = useUnit([
    articlesEntityModel.$filters,
    articlesEntityModel.updateFilter,
    articlesEntityModel.applyFilters,
    articlesEntityModel.resetFilters,
  ]);

  return (
    <Paper>
      <Flex gap="md" align="flex-end" wrap={{ base: "wrap", md: "nowrap" }}>
        <TextInput
          miw={{ md: "320px", base: "auto" }}
          mt="xs"
          placeholder="Enter article URL"
          size="md"
          flex={1}
          value={filters.url}
          onChange={(e) => update({ url: e.currentTarget.value })}
        />

        <DatePickerInput
          w="100%"
          size="md"
          valueFormat="DD/MM/YYYY"
          type="range"
          placeholder="Select date range"
          value={[filters.createdFrom || null, filters.createdTo || null]}
          onChange={([from, to]) =>
            update({ createdFrom: from, createdTo: to })
          }
        />

        <Select
          size="md"
          w="100%"
          data={[
            { value: "", label: "All Tasks" },
            { value: ArticleStatus.pending, label: "In progress" },
            { value: ArticleStatus.failed, label: "Failed" },
            { value: ArticleStatus.completed, label: "Finished" },
          ]}
          value={filters.status ?? ""}
          onChange={(value) => update({ status: value ?? "" })}
        />

        <Flex align="center" gap="md" w="100%">
          <Button fullWidth size="md" onClick={apply}>
            Apply
          </Button>

          <Button fullWidth variant="light" size="md" onClick={reset}>
            Reset
          </Button>
        </Flex>
      </Flex>
    </Paper>
  );
};
